import { yupResolver } from "@hookform/resolvers/yup";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import * as yup from "yup";
import AuthApi from "../../apis/auth.api";
import AppAlert from "../../components/AppAlert";
import SolidBlueBtn from "../../components/buttons/SolidBlueBtn";
import AppInput from "../../components/controls/AppInput";
import Spinner from "../../components/spinner/Spinner";
import TopPageBack from "../../components/TopPageBack";
import { RESULT_CODE } from "../../constants/AppConstants";
import { ROUTE_PATHS } from "../../constants/Router";
import useAuth from "../../hooks/useAuth";
import AppUtils from "../../utils";

const FindId = function () {
  const [openNoResult, setOpenNoResult] = useState(false);
  const [openIncorrectNumber, setOpenIncorrectNumber] = useState(false);
  const navigate = useNavigate();
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);

  const schema = yup.object().shape({
    bizNo: yup.string().required(),
    ownerName: yup.string().required(),
    ownerPhone: yup.string().required(),
  });
  const { control, handleSubmit, watch } = useForm({
    resolver: yupResolver(schema),
  });

  const onSubmit = async (data) => {
    const removedDashPhoneNumber = AppUtils.replaceDash(data.ownerPhone);
    const removedDashBizNo = AppUtils.replaceDash(data.bizNo);
    if (
      removedDashPhoneNumber.length >= 9 &&
      removedDashPhoneNumber.length <= 11 &&
      removedDashPhoneNumber.startsWith("010")
    ) {
      const submitData = {
        ...data,
        ownerPhone: removedDashPhoneNumber,
        bizNo: removedDashBizNo,
      };
      try {
        setLoading(true);
        const res = await AuthApi.forgetId(submitData);
        if (res.data && res.data.result_code !== RESULT_CODE.NO_RESULT) {
          navigate(ROUTE_PATHS.VerifyCode, {
            state: {
              data: submitData,
              phoneNumber: data.ownerPhone,
              shopIdx: res.data.data.shopIdx,
              type: "find-id",
            },
          });
        } else {
          setOpenNoResult(true);
        }
      } catch (error) {
        setOpenNoResult(true);
      } finally {
        setLoading(false);
      }
    } else {
      setOpenIncorrectNumber(true);
    }
  };

  const values = watch();

  return (
    <div>
      <TopPageBack>
        <b>아이디 찾기</b>
      </TopPageBack>

      <div className="mt-4 mx-5">
        <form onSubmit={handleSubmit(onSubmit)}>
          <AppInput
            control={control}
            name="bizNo"
            placeholder="사업자번호를 입력해 주세요."
            label="사업자등록번호"
            className="mb-5"
            type="number"
          />

          <AppInput
            control={control}
            name="ownerName"
            placeholder="대표자 이름을 입력해 주세요."
            label="대표자명"
            className="mb-5"
          />

          <AppInput
            control={control}
            name="ownerPhone"
            placeholder="대표자 휴대폰 번호를 입력해 주세요."
            label="휴대폰 번호"
            maximum={11}
            isKoreaPhoneNumber
            type="number"
          />

          <div className="px-5 absolute w-full bottom-2 left-0">
            <SolidBlueBtn
              disabled={
                !values.bizNo ||
                !values.ownerPhone ||
                !values.ownerName ||
                loading
              }
              className="w-full mt-5  flex items-center justify-center"
              type="submit"
            >
              <Spinner isLoading={loading} />
              인증번호 받기
            </SolidBlueBtn>
          </div>
        </form>
      </div>

      <AppAlert
        title="아이디를 찾을 수 없어요."
        desc="입력한 정보가 맞는지 확인하거나 <br /> 매장 담당자에게 연락해 주세요."
        open={openNoResult}
        onOk={() => setOpenNoResult(false)}
        okText="확인"
        type="error"
      />

      <AppAlert
        title="휴대폰 번호가 올바르지 않아요."
        desc="번호를 다시 한번 확인해 주세요."
        open={openIncorrectNumber}
        onOk={() => setOpenIncorrectNumber(false)}
        okText="확인"
        type="error"
      />
    </div>
  );
};
export default FindId;
